import { render, staticRenderFns } from "./earlyWarnModal.vue?vue&type=template&id=b87475c6&scoped=true"
import script from "./earlyWarnModal.vue?vue&type=script&lang=js"
export * from "./earlyWarnModal.vue?vue&type=script&lang=js"
import style0 from "./earlyWarnModal.vue?vue&type=style&index=0&id=b87475c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87475c6",
  null
  
)

export default component.exports